
import Component, { mixins } from 'vue-class-component'
import NewsMixin from './news-mixin/index'
import NewsItem from '@/components/news-item/index.vue'
import ItemTitle from '@/components/item-title/index.vue'
import { Prop, Watch } from 'vue-property-decorator'
@Component({
  components: {
    ItemTitle,
    NewsItem
  }
})

export default class Index extends mixins(NewsMixin) {
  @Watch('menuId')
  onmenuIdchange (val: any): void {
    if (!val) {
      return
    }
    this.manager.menuId = val
    this.manager.init()
  }

  showDetail (info: any) {
    window.location.href = (`/infoNews.html#/news/${info.id}/${this.menuTitle}`)
  }

  seeMore () {
    window.location.href = (`/news.html#/${this.menuId}/${this.menuTitle}`)
  }
}
